import { faSquareList } from "@fortawesome/pro-duotone-svg-icons";
import { signal } from "@preact/signals-react";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Grid, GridColumn, GridNoRecords } from "@progress/kendo-react-grid";
import { Checkbox, Input } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";
import { ColorChangingIcon } from "../../Common/UI/ColorChangingIcon";
import { FieldTypes } from "../../Fields/FieldTypes/Fields";
import {
  columnsConstructorSessionData,
  propertiesVisible,
  selectedColumnId,
  validateColumnName,
} from "./ColumnsConstructorSignals";

export const ColumnsConstructorGrid = () => {
  return (
    <Grid
      style={{ height: "100%" }}
      data={columnsConstructorSessionData.value}
      dataItemKey="id"
      selectable={{
        enabled: true,
        drag: false,
        cell: false,
        mode: "single",
      }}
    >
      <GridNoRecords>This Table has no Columns defined.</GridNoRecords>
      <GridColumn
        title=""
        width="50px"
        cells={{
          data: (e) => selectedCell({ dataItem: e.dataItem }),
        }}
      />
      <GridColumn
        field="columnName"
        title="Column Name"
        cells={{
          data: (e) => cellColumnName({ dataItem: e.dataItem }),
        }}
      />
      <GridColumn
        field="columnType"
        title="Column Type"
        cells={{
          data: (e) => cellColumnType({ dataItem: e.dataItem }),
        }}
      />
      <GridColumn
        cells={{
          data: (e) => cellWithPropertiesButton({ dataItem: e.dataItem }),
        }}
      />
    </Grid>
  );
};

//#region Custom Grid Cells

const cellWithPropertiesButton = ({ dataItem }) => {
  const dataRow = signal({ ...dataItem });

  return (
    <td>
      <ColorChangingIcon
        title="Properties"
        icon={faSquareList}
        initialPrimaryColor="#a6e6ff"
        initialSecondaryColor="#0078d4"
        onClick={() => {
          gridCellUpdateFocus(dataRow);
          propertiesVisible.value = !propertiesVisible.value;
        }}
      />
    </td>
  );
};

const gridCellUpdateFocus = (dataRow) => {
  selectedColumnId.value = dataRow.value.id;
};

const cellColumnName = ({ dataItem }) => {
  const dataRow = signal({ ...dataItem });

  const handleChange = (e) => {
    dataRow.value = { ...dataRow.value, columnName: e.target.value };
  };

  const handleBlur = (e) => {
    const updatedRows = [...columnsConstructorSessionData.value];
    const index = updatedRows.findIndex((row) => row.id === dataRow.value.id);
    updatedRows[index] = { ...dataRow.value, columnName: e.target.value };
    columnsConstructorSessionData.value = updatedRows;
  };

  const validation = validateColumnName(dataRow.value.columnName || "", dataRow.value.id);

  return (
    <td className="k-vertical-align-top">
      <Input
        defaultValue={dataRow.value.columnName || ""}
        onChange={(e) => handleChange(e)}
        onBlur={(e) => handleBlur(e)}
        onFocus={() => {
          gridCellUpdateFocus(dataRow);
        }}
        required={true}
        valid={validation.isValid}
      />
      {!validation.isValid && <Error>{validation.errorMessage}</Error>}
    </td>
  );
};

const cellColumnType = ({ dataItem }) => {
  const dataRow = signal({ ...dataItem });

  const handleChange = (e) => {
    dataRow.value = { ...dataRow.value, columnType: e.target.value };
    const updatedRows = columnsConstructorSessionData.value.map((row) => {
      if (row.id === dataRow.value.id) {
        return {
          ...row,
          columnType: e.target.value,
        };
      }
      return row;
    });
    columnsConstructorSessionData.value = updatedRows;
  };

  return (
    <td className="k-vertical-align-top">
      <DropDownList
        style={{ padding: 0, verticalAlign: "top" }}
        data={FieldTypes.filter(
          (field) =>
            field !== "Gallery" &&
            field !== "Table" &&
            field !== "FileUpload" &&
            field !== "Index" &&
            field !== "ContinuousComments"
        )}
        defaultValue={dataRow.value.columnType}
        onChange={(e) => {
          handleChange(e);
        }}
        onFocus={() => {
          gridCellUpdateFocus(dataRow);
        }}
        required={true}
      />
      {!dataRow.value.columnType && <Error>Column Type is required.</Error>}
    </td>
  );
};

const selectedCell = ({ dataItem }) => {
  const dataRow = signal({ ...dataItem });
  const handleChange = () => {
    selectedColumnId.value = dataRow.value.id;
  };

  return (
    <td>
      <Checkbox
        value={selectedColumnId.value === dataRow.value.id}
        onChange={() => {
          handleChange();
        }}
      />
    </td>
  );
};
//#endregion Custom Grid Cells
